<template>
  <div>
    <div v-if="!embeddedDefinition" class="task taskDefinition">
      <button @click="loadDefinition()" type="button" class="w3-buttonTask">
        <transition name="fade" mode="out-in">
          <spinner-loading v-if="taskLoading" class="spinner-loading" :size="23" :line-size='2' line-fg-color='#5dbecd' />
          <div v-else>
            <i :class="['sherpa-icon', 'icon-' + task.taskId]"></i>
            <span>{{ task.label }}</span>
          </div>
        </transition>
      </button>
    </div>
    <transition name="fade" mode="out-in">
      <popup v-if="!embeddedDefinition && isPopupShown && content"
        :isPopupShown="isPopupShown"
        :title="task.info"
        :type="getTaskType()"
        :id="task.taskId"
        :content="content"
        :language="language"
        :authorization="authorization"
        :visuals="visuals"
        :apiparams="apiparams"
        :definitionContentId="definitionContentId"
        @popupClose="popupClose"
      />
      <definition v-else-if="embeddedDefinition && content"
        :type="getTaskType()"
        :content="content"
        :id="task.taskId"
        :language="language"
        :visuals="visuals"
        :authorization="authorization"
        :apiparams="apiparams"
        :fromPopup="false"
        :showloading="true"
        :embeddedDefinition="embeddedDefinition"
        :builderModifyCall="builderModifyCall"
        :builderDeleteCall="builderDeleteCall"
        @definitionloaded="definitionloaded"
        @definitionsaved="definitionsaved"
        @definitionupdated="definitionupdated"
        @definitiondeleted="definitiondeleted"
        @definitionerror="definitionerror"
        @validatingFormError="validatingFormError"
      />
    </transition>
  </div>
</template>

<script>
import Popup from '../../popup'
import * as api from '../../utils/definitionApi'
import language from '../../language'
import transport from 'vue-definition-utils/src/utils/transport'

export default {
  name: 'definition-task-definition',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'apiparams',
    'visuals',
    'embeddedDefinition',
    'builderModifyCall',
    'builderDeleteCall',
    'repeatableItemIndex',
    'calledTaskIndex',
    'callTask'
  ],
  components: {
    Popup,
    Definition: () => import('../../definition.vue') // Webpack’s asynchronous import for recursivity components
  },
  data () {
    return {
      isPopupShown: false,
      content: null,
      taskLoading: false
    }
  },
  beforeMount () {
    if (this.embeddedDefinition) {
      this.loadDefinition()
    }
  },
  methods: {
    getTaskType () {
      this.task.type.domainEndpoint = this.type.domainEndpoint
      this.task.type.token = this.type.token
      this.task.type.version = this.type.version
      return this.task.type
    },
    popupClose () {
      this.isPopupShown = false
      this.taskLoading = false

      if (this.task.persist) {
        if (this.task.menuId) {
          if (this.$route.name === this.task.menuId) {
            this.$emit('refreshDefinitionContent')
          } else {
            this.$router.push({name: this.task.menuId, params: { id: this.definitionContentId }}).catch(() => {})
          }
        }
      } else {
        this.$emit('popupClose')
      }
    },
    definitionloaded (content) {
      this.$emit('definitionloaded', content)
    },
    definitionsaved (object, response) {
      this.$emit('definitionsaved', object, response)
    },
    definitionupdated (object, response) {
      this.$emit('definitionupdated', object, response)
    },
    definitiondeleted (object, response) {
      this.$emit('definitiondeleted', object, response)
    },
    definitionerror (error, resultError, container) {
      this.$emit('definitionerror', error, resultError, container)
    },
    validatingFormError () {
      this.$emit('validatingFormError')
    },
    loadDefinition () {
      this.taskLoading = true

      // -- menu id with endpoint info depending of defined alias value
      if (this.task.menuId && this.task.menuId !== '' && this.isJSON(this.task.menuId)) {
        var menuIdObj = JSON.parse(this.task.menuId)
        var menuIdAlias = transport.methods.getRequestObjectById(menuIdObj.alias, this.object).domainValue[0].key
        var menuValue = menuIdObj.values[menuIdAlias]

        if (menuValue) {
          if (menuValue.endpoint) {
            this.task.type.endpoint = menuValue.endpoint
          }
          if (menuValue.modeview) {
            this.task.type.modeView = menuValue.modeview
          }
          if (!this.task.type.actions) {
            this.task.type.actions = {}
          }
          if (menuValue.create) {
            if (!this.task.type.actions.create) {
              this.task.type.actions.create = {}
            }
            this.task.type.actions.create.endpoint = menuValue.create
          }
          if (menuValue.update) {
            if (!this.task.type.actions.update) {
              this.task.type.actions.update = {}
            }
            this.task.type.actions.update.endpoint = menuValue.update
          }
          if (menuValue.delete) {
            if (!this.task.type.actions.delete) {
              this.task.type.actions.delete = {}
            }
            this.task.type.actions.delete.endpoint = menuValue.delete
          }
        }
      }

      api.call({
        domainEndpoint: this.type.domainEndpoint,
        url: this.task.type.endpoint,
        token: this.type.token,
        version: this.type.version,
        method: 'POST',
        lang: this.getLang(),
        authorization: this.authorization,
        data: {
          id: this.definitionContentId,
          code: this.repeatableGroupCode,
          requestObject: this.object
        }
      })
        .then(resp => {
          this.isPopupShown = true
          this.content = resp
        })
        .catch(err => {
          console.error(err)
        })
    },
    getLang (key) {
      return language(this.language, key)
    },
    isJSON (str) {
      try {
        return (JSON.parse(str) && !!str)
      } catch (e) {
        return false
      }
    }
  },
  watch: {
    calledTaskIndex: {
      handler: function (val) {
        if (val.index === this.repeatableItemIndex) {
          this.loadDefinition()
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/task/taskDefinition.vue